import { render, staticRenderFns } from "./SysAnnouncementList.vue?vue&type=template&id=1ef4ea49&scoped=true"
import script from "./SysAnnouncementList.vue?vue&type=script&lang=js"
export * from "./SysAnnouncementList.vue?vue&type=script&lang=js"
import style0 from "./SysAnnouncementList.vue?vue&type=style&index=0&id=1ef4ea49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef4ea49",
  null
  
)

export default component.exports